angular.module('tgaAdmin').directive('fileUpload', () => ({
  require: 'ngModel',
  link(scope, el, attrs, ngModel) {
    el.on('change', () => {
      const files = {
        file: el[0].files,
      };
      if (el[0].files.length === 1) {
        [files.file] = el[0].files;
      }
      ngModel.$setViewValue(files);
    });
  },
}));
